import React, { Suspense } from 'react'
// @ts-ignore
import Tree from 'react-d3-tree'
import { Tooltip } from '@chakra-ui/react'
import { LINEAGE_DATA } from '../../lib/lineage'

type RawNodeDatum = {
  name: string
  attributes?: Record<string, string>
  children?: RawNodeDatum[]
}

const Lineage: React.FC = () => {
  const treeData: RawNodeDatum = {
    name: 'Welcome to the Up&Up Family!',
    children: [
      {
        name: 'The Parents',
        children: Object.values(LINEAGE_DATA)
          .filter((person) => person.isParent)
          .map((person) => ({
            name: person.name,
            attributes: {
              role: person.role,
              desc: person.desc,
              ...(person.deceased && { deceased: 'true' })
            }
          }))
      },
      {
        name: 'The Children',
        children: Object.values(LINEAGE_DATA)
          .filter((person) => !person.isParent)
          .map((person) => ({
            name: person.name,
            attributes: {
              role: person.role,
              desc: person.desc,
              ...(person.deceased && { deceased: 'true' })
            }
          }))
      }
    ]
  }

  const nodeWidth = 120
  const nodeHeight = 80

  const renderNode = ({ nodeDatum, foreignObjectProps }: any) => {
    const isDeceased = nodeDatum.attributes?.deceased === 'true'

    return (
      <g>
        <foreignObject {...foreignObjectProps}>
          <Tooltip label={nodeDatum.attributes?.desc} hasArrow placement='top'>
            <div
              style={{
                width: nodeWidth - 10,
                height: nodeHeight - 10,
                backgroundColor: isDeceased ? '#f5f5f5' : '#fff',
                border: '2px solid #ccc',
                borderRadius: '5px',
                padding: '5px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '12px',
                cursor: 'pointer',
                textAlign: 'center',
                opacity: isDeceased ? 0.7 : 1,
                color: isDeceased ? '#666' : 'inherit'
              }}
            >
              <div style={{ width: '100%', textAlign: 'center' }}>{nodeDatum.name}</div>
              <div
                style={{
                  width: '100%',
                  fontSize: '10px',
                  color: isDeceased ? '#999' : '#666',
                  textAlign: 'center'
                }}
              >
                {nodeDatum.attributes?.role}
                {isDeceased && ' 🕊️'}
              </div>
            </div>
          </Tooltip>
        </foreignObject>
      </g>
    )
  }

  return (
    <div
      className='lineage-container'
      style={{ width: '100vw', height: '100vh', overflow: 'auto' }}
    >
      <div style={{ width: '100%', height: 'calc(100vh - 60px)' }}>
        <Suspense fallback={<div>Loading tree...</div>}>
          <Tree
            data={treeData}
            dimensions={{
              width: window.innerWidth,
              height: window.innerHeight - 60
            }}
            nodeSize={{
              x: nodeWidth * 2,
              y: nodeHeight * 2
            }}
            renderCustomNodeElement={(rd3tProps) =>
              renderNode({
                ...rd3tProps,
                foreignObjectProps: {
                  width: nodeWidth,
                  height: nodeHeight,
                  x: -nodeWidth / 2,
                  y: -nodeHeight / 2
                }
              })
            }
            orientation='vertical'
          />
        </Suspense>
      </div>
    </div>
  )
}

export default Lineage
